import { CookieCategory } from '../api/cookie-category';

export const CookieCategories: CookieCategory[] = [
    {
        label: $localize`Funkcjonalne (niezbędne pliki cookie)`,
        description: $localize`Te pliki cookie są niezbędne do zapewnienia podstawowej funkcjonalności witryny oraz obsługi płatności i sesji użytkownika.`,
        setting: 'functionality',
        isRequired: true,
        cookiesList: [
            {
                name: 'cookie-settings',
                description: $localize`Przechowuje preferencje użytkownika dotyczące ciasteczek ustawione w popupie.`,
                data: $localize`1 rok`
            },
            {
                name: '_grecaptcha',
                description: $localize`Dane potrzebne do poprawnego działania systemu Google ReCaptcha v3, który zapewnia niniejszej stronie zabezpieczenie antyspamowe.`,
                data: $localize`6 miesięcy`
            },
            {
                name: $localize`Google Recaptcha V3`,
                description: $localize`Pliki Cookies używane do ochrony stron internetowych przed spamem i nadużyciami. Pomaga rozróżnić działania ludzi od automatycznych botów, analizując zachowanie użytkownika podczas interakcji ze stroną. Cookie to gromadzi anonimowe dane, takie jak czas spędzony na stronie czy ruchy myszką, aby ocenić, czy użytkownik jest człowiekiem, bez ingerencji w treści witryny.`
            }
        ]
    },
    {
        label: $localize`Preferencje (opcjonalne)`,
        description: $localize`Te pliki cookie zapisują Twoje preferencje na naszej stronie, ułatwiając nawigację i personalizując Twoje doświadczenie użytkownika.`,
        setting: 'preferences',
        isRequired: false,
        cookiesList: []
    },
    {
        label: $localize`Statystyka (opcjonalne)`,
        description: $localize`Te pliki cookie są używane do zbierania statystyk odwiedzin strony, pomagają nam ulepszać Twoje doświadczenie online.`,
        setting: 'statistics',
        isRequired: false,
        cookiesList: []
    },
    {
        label: $localize`Marketing (opcjonalne)`,
        description: $localize`Te pliki cookie są używane do celów marketingowych, śledząc preferencje i zachowania użytkowników, aby dostarczać spersonalizowane reklamy i oferty.`,
        setting: 'marketing',
        isRequired: false,
        cookiesList: []
    },
];
